import React, { useState } from 'react';

import { Divider, Group, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { AthleteAppointmentWithAthlete } from 'types';

import LateCancelNoShowAthlete from './components/LateCancelNoShowAthleteAppointments';
import ModalAthleteAppointmentDelete from '../ModalAthleteAppointmentDelete';

interface ILateCancelAthletesProps {
  athleteAppointments: AthleteAppointmentWithAthlete[];
  totalAthleteAppointmentsLength: number;
  handleCloseDrawer: () => void;
  permission?: boolean;
}

const LateCancelNoShowAthleteAppointments = ({
  athleteAppointments,
  totalAthleteAppointmentsLength,
  handleCloseDrawer,
  permission = true,
}: ILateCancelAthletesProps): JSX.Element => {
  const [athleteAppointmentId, setAthleteAppointmentId] = useState<string>('');
  const [deleteModalOpened, { open: openDeleteModal, close: closeDeleteModal }] = useDisclosure(false);

  const handleDeleteModal = (id: string): void => {
    setAthleteAppointmentId(id);
    openDeleteModal();
  };

  if (athleteAppointments.length) {
    return (
      <>
        <Stack spacing={0} pt='xs'>
          {athleteAppointments.map((akc, index) => {
            return (
              <LateCancelNoShowAthlete
                athleteAppointment={akc}
                permission={permission}
                index={index}
                key={index}
                handleDeleteModal={handleDeleteModal}
              />
            );
          })}
          <Divider />
        </Stack>
        <ModalAthleteAppointmentDelete
          opened={deleteModalOpened}
          handleClose={closeDeleteModal}
          handleCloseDrawer={handleCloseDrawer}
          athleteAppointmentId={athleteAppointmentId}
          athleteAppointmentsLength={totalAthleteAppointmentsLength}
        />
      </>
    );
  }
  return (
    <Group position='center'>
      <Text color='dimmed'>No athletes to display</Text>
    </Group>
  );
};
export default LateCancelNoShowAthleteAppointments;
